import { useRef, useState } from "react";
import { useUserSearch } from "./useUserSearch";
import { UserSuggestions } from "./UserSuggestions";

// Text input/textarea with @username autocomplete.
export const MentionInput = ({ as = "input", value, onChange, wrapperClassName = "", up = false, onKeyDown, ...rest }) => {
  const ref = useRef(null);
  const [query, setQuery] = useState(null);
  const [active, setActive] = useState(0);
  const users = useUserSearch(query);

  const detect = (val, caret) => {
    const m = /(^|\s)@([a-zA-Z0-9_]{1,24})$/.exec(val.slice(0, caret));
    setQuery(m ? m[2] : null);
    setActive(0);
  };

  const pick = (u) => {
    const el = ref.current;
    const caret = el.selectionStart;
    const before = value.slice(0, caret).replace(/@([a-zA-Z0-9_]{1,24})$/, `@${u.username} `);
    const next = before + value.slice(caret);
    onChange(next);
    setQuery(null);
    requestAnimationFrame(() => { el.focus(); el.setSelectionRange(before.length, before.length); });
  };

  const keyDown = (e) => {
    if (query != null && users.length) {
      if (e.key === "ArrowDown") { e.preventDefault(); setActive((a) => (a + 1) % users.length); return; }
      if (e.key === "ArrowUp") { e.preventDefault(); setActive((a) => (a - 1 + users.length) % users.length); return; }
      if (e.key === "Enter" || e.key === "Tab") { e.preventDefault(); pick(users[active]); return; }
      if (e.key === "Escape") { setQuery(null); return; }
    }
    onKeyDown?.(e);
  };

  const Tag = as;
  return (
    <div className={`relative ${wrapperClassName}`}>
      <Tag
        ref={ref}
        value={value}
        onChange={(e) => { onChange(e.target.value); detect(e.target.value, e.target.selectionStart); }}
        onKeyDown={keyDown}
        onBlur={() => setTimeout(() => setQuery(null), 120)}
        {...rest}
      />
      {query != null && <UserSuggestions users={users} active={active} onPick={pick} up={up} testid={`${rest["data-testid"] || "mention"}-suggestions`} />}
    </div>
  );
};
